//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'pagination',
  props: {
    currentPage: { // 当前第几页
      type: Number,
      default: 1
    },
    allPage: { // 总页数
      type: Number,
      default: 10
    },
    showIndex: { // 中间显示几个页数，要为奇数
      type: Number,
      default: 5
    }
  },
  methods: {
    nextPage () {
      this.$emit('setPage', this.currentPage + 1)
    },
    prevPage () {
      this.$emit('setPage', this.currentPage - 1)
    },
    btnClick (num) {
      if (num !== this.currentPage) {
        this.$emit('setPage', num)
      }
    }
  },
  computed: {
    indexs () {
      var left = 1
      var right = this.allPage
      var arr = []
      var index = parseInt(this.showIndex / 2)
      var middleIndex = index + 1
      if (this.allPage >= this.showIndex) {
        if (this.currentPage > middleIndex && this.currentPage < this.allPage - index) {
          left = this.currentPage - index
          right = this.currentPage + index
        } else if (this.currentPage <= middleIndex) {
          left = 1
          right = this.showIndex
        } else {
          left = this.allPage - (this.showIndex - 1)
          right = this.allPage
        }
      }
      while (left <= right) {
        arr.push(left)
        left++
      }
      return arr
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pagination.vue